import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Home from './containers/Home';
import Login from './containers/Login';
import Abc from './containers/Abc';
import Signup from './containers/Signup';
import Activate from './containers/Activate';
import ResetPassword from './containers/ResetPassword';
import Contact from './containers/Contact';
import AddProduct from './containers/AddProduct';
import ResetPasswordConfirm from './containers/ResetPasswordConfirm';
import Layout from './hocs/Layout';
import About from './containers/About';
import PrivateRoute from './components/PrivateRoute';
import BuyerItems from './containers/BuyerItems';
import Item from './containers/Item';
import Order from './containers/Order';
import SellerDashboard from './containers/SellerDashboard';
import BuyerDashboard from './containers/BuyerDashboard';
import { Provider } from 'react-redux';
import store from './store';
import './index.css'
import Searched from './containers/searched';
import Cart from './containers/Cart';
import AdminMenu from './containers/AdminMenu';
import Calculator from './containers/Calculator';
import StoreServices from './containers/StoreServices';
import StoreProducts from './containers/StoreProducts';



const App = () => (
  <Provider store={store}>
    <Router>
      <Layout>
        <Switch>
          <Route exact path='/' component={Home} />
          <PrivateRoute exact path='/abc' component={Abc} />
          <Route exact path='/login' component={Login} />
          <Route exact path='/signup' component={Signup} />
          <Route exact path='/about' component={About} />
          <Route exact path='/contact' component={Contact} />
          <Route exact path='/add' component={AddProduct} />
          <Route exact path='/items' component={BuyerItems} />
          <Route exact path='/item' component={Item} />
          <Route exact path='/order' component={Order} />
          <Route exact path='/reset-password' component={ResetPassword} />
          <Route exact path='/password/reset/confirm/:uid/:token' component={ResetPasswordConfirm} />
          <Route exact path='/activate/:uid/:token' component={Activate} />
          <Route exact path='/categories' component={AdminMenu} />
          <Route exact path='/SellerDashboard' component={SellerDashboard} />
          <Route exact path='/Searched' component={Searched} />
          <Route exact path='/BuyerDashboard' component={BuyerDashboard} />
          <Route exact path='/cart' component={Cart} />
          <Route exact path='/calculator' component={Calculator} />
          <Route exact path='/store-services' component={StoreServices} />
          <Route exact path='/store-prodcuts' component={StoreProducts} />
          
        </Switch>
      </Layout>
    </Router>
  </Provider>
  );
  

  export default App;